<template>
  <div class="withdrawBank-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="银行名称" size="small" class="param-input" v-model="params.bankName"></el-input>
      <el-input placeholder="银行代号" size="small" class="param-input" v-model="params.bankCode"></el-input>
      <el-button type="primary" size="small" @click="searchAction">搜索</el-button>
      <el-button type="primary" size="small" @click="tagsAction('add')">新增</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="ID" label="ID" align="center"></el-table-column>
      <el-table-column prop="bankName" label="银行名称" align="center"></el-table-column>
      <el-table-column prop="bankCode" label="银行代号" align="center"></el-table-column>
      <el-table-column prop="icon" label="银行标志" align="center">
        <template slot-scope="scope">
          <img-load :width="'150px'" :height="'80px'" :src="imgUrl + scope.row.icon"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="img" label="背景图" align="center">
        <template slot-scope="scope">
          <img-load :width="'150px'" :height="'80px'" :src="imgUrl + scope.row.img"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="修改时间" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button type="success" class="el-icon-edit" size="mini" @click="tagsAction('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove(scope.row.ID)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[5, 15, 20, 25]" layout="total, sizes, prev, pager, next, jumper" :total="total" background :current-page="params.pageNumber" :page-size="params.pageSize" v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑tag弹窗-->
    <edit-bank ref="editBank" @handlerTagList="handlerTagList"></edit-bank>
  </div>
</template>
<script>
import editBank from './components/edit-bank'
import baseConfig from '@/utils/serverUrlConfig'
import API from '@/api'

export default {
  data() {
    return {
      loading: false,
      total: 0,
      // 列表数据
      tableData: [],
      imgUrl: baseConfig.imgUrl,
      // 列表请求参数
      params: {
        pageNumber: 1,
        pageSize: 20,
        bankName: '',
        bankCode: '',
      }
    }
  },
  components: {
    editBank,
  },
  created() {
    this.cashBankList()
  },
  methods: {
    // 搜索符合条件列表
    searchAction() {
      this.params.pageNumber = 1
      this.cashBankList()
    },
    // 新增、编辑tags
    tagsAction(type, data) {
      this.$refs.editBank.open(type, data);
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerTagList() {
      this.cashBankList()
    },
    // 删除标签
    remove(row) {
      this.$confirm('您确定要删除当当前视频吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          API.delCashBank({ id: row }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.cashBankList()
            } else {
              this.$message.error('删除失败！');
            }
          })
        })
    },
    // 提现银行配置列表请求
    cashBankList() {
      this.loading = true
      API.cashBankList(this.params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.cashBankList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.cashBankList()
    },
  }
}
</script>

